export const AuthConstants = {
  KEYS: {
    ID_TOKEN: "id_token_claims_obj",
    ACCESS_TOKEN: "access_token",
    REFRESH_TOKEN: "refresh_token",
    AUTHORITIES: "authorities",
  },
  ROLES: {
    ADMIN: "ADMIN",
    MLB: "MLB",
    AFL: "AFL",
    WBC: "WBC",
    AFL_ADMIN: "AFL_ADMIN",
    WBC_ADMIN: "WBC_ADMIN",
    VIEW_ONLY: "VIEW_ONLY",
    CUSTOM_CARD: "CUSTOM_CARD",
  },
};
